<template>
	<div class="tw:self-center tw:ms-1.5">
		<div v-if="showCompare" class="tw:text-sm tw:text-zinc-600 tw:line-through tw:px-2 tw:my-1 tw:text-end">{{ format(compareAt) }}</div>
		<div class="tw:flex tw:justify-end">
			<div class="tw:self-end" v-if="showCompare && discountInPercent >= 5">
				<div class="tw:text-base tw:font-bold tw:bg-red-600 tw:shadow tw:px-2 tw:py-0.5 tw:text-white tw:-ml-1.5 tw:transform tw:transform-[skewX(-12deg)]">
					<span class="tw:transform tw:transform-[skewX(12deg)] tw:whitespace-nowrap">
						{{$t('Spar')}} {{ format(compareAt - price) }}
					</span>
				</div>
			</div>
			<div class="tw:text-xl tw:font-bold tw:bg-(--shop-primary) tw:shadow tw:py-1 tw:px-2 tw:text-white tw:transform tw:transform-[skewX(-12deg)]">
				<span class="tw:transform tw:transform-[skewX(12deg)] tw:whitespace-nowrap">
					{{ format(price) }}
				</span>
			</div>
		</div>
        <div v-if="deliveryFee" class="tw:text-sm tw:text-zinc-600 tw:px-2 tw:my-1">+ {{ $t('Fraktkostnad') + ' ' + format(deliveryFee) }}</div>
	</div>
  
</template>

<script setup>
	import { computed } from 'vue'
	const props = defineProps({
		price: { type: Number, required: true },
		compareAt: { type: Number, required: false },
        discountInPercent: { type: Number, required: false },
        deliveryFee: { type: Number, required: false },
	})

	const showCompare = computed(() => props.compareAt && props.compareAt > props.price)

	const format = (n) => window.TABS.L10n.money.parse(n).format()
</script>

<style scoped>
</style>
